module.exports = __webpack_public_path__ + "img/x.6a5a9dbc.svg";